import axios, { CancelToken } from 'axios';

import { QUALITY_MONITOR } from 'RestAPIs/endpoints';

export type OpenRequestStatusCategory =
  | 'OPEN'
  | 'IN_ROSTER_MATCH'
  | 'SENT_TO_FLEX'
  | 'OPEN_FOR_SELF_MATCH'
  | 'PARKED';

type Day = {
  date: string;
  totalNumberOfActions: number;
  actionsPerStatus: Partial<Record<OpenRequestStatusCategory, number>>;
};

export type Entry = {
  costCenterId: number;
  costCenterName: string;
  days: Day[];
};

type Options = {
  params: {
    costCenterIds: string;
    startDate: string;
    endDate: string;
  };
  cancelToken: CancelToken;
};

export const getData = (options: Options) =>
  axios.get<Entry[]>(QUALITY_MONITOR, { ...options });
